import gql from 'graphql-tag';

export const fields = `
    aircraftModel {
        id
        name
        totalMotors
    }
    aircraftStatus {
        id
        name
    }
`;

export const relationsFields = `
`;

// default methods
export const paginationQuery = gql`
    query DigitaiPaginateAircraftModelsAircraftStatuses (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        pagination: digitaiPaginateAircraftModelsAircraftStatuses (
            query: $query
            constraint: $constraint
        ) {
            total
            rows
            count
        }
    }
`;

export const getQuery = gql`
    query DigitaiGetAircraftModelsAircraftStatuses (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        objects: digitaiGetAircraftModelsAircraftStatuses (
            query: $query
            constraint: $constraint
        ) {
            aircraftModelId
            aircraftStatusId
            #FIELDS
        }
    }
`;

export const findByIdQuery = gql`
    query DigitaiFindAircraftModelAircraftStatusById (
        $aircraftModelId: ID
        $aircraftStatusId: ID
        $constraint: QueryStatement
    ) {
        object: digitaiFindAircraftModelAircraftStatusById (
            aircraftModelId: $aircraftModelId
            aircraftStatusId: $aircraftStatusId
            constraint: $constraint
        ) {
            aircraftModelId
            aircraftStatusId
            #FIELDS
        }
    }
`;

export const findQuery = gql`
    query DigitaiFindAircraftModelAircraftStatus (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        object: digitaiFindAircraftModelAircraftStatus (
            query: $query
            constraint: $constraint
        ) {
            aircraftModelId
            aircraftStatusId
            #FIELDS
        }
    }
`;

export const createMutation = gql`
    mutation DigitaiCreateAircraftModelAircraftStatus (
        $payload: DigitaiCreateAircraftModelAircraftStatusInput!
    ) {
        digitaiCreateAircraftModelAircraftStatus (
            payload: $payload
        ) {
            ${fields}
        }
    }
`;

export const insertMutation = gql`
    mutation DigitaiCreateAircraftModelsAircraftStatuses (
        $payload: [DigitaiCreateAircraftModelAircraftStatusInput]!
    ) {
        digitaiCreateAircraftModelsAircraftStatuses (
            payload: $payload
        )
    }
`;

export const updateByIdMutation = gql`
    mutation DigitaiUpdateAircraftModelAircraftStatusById (
        $payload: DigitaiUpdateAircraftModelAircraftStatusByIdInput!
        $constraint: QueryStatement
    ) {
        digitaiUpdateAircraftModelAircraftStatusById (
            payload: $payload
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const updateMutation = gql`
    mutation DigitaiUpdateAircraftModelsAircraftStatuses (
        $payload: DigitaiUpdateAircraftModelsAircraftStatusesInput!
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiUpdateAircraftModelsAircraftStatuses (
            payload: $payload
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteByIdMutation = gql`
    mutation DigitaiDeleteAircraftModelAircraftStatusById (
        $aircraftModelId: ID!
        $aircraftStatusId: ID!
        $constraint: QueryStatement
    ) {
        digitaiDeleteAircraftModelAircraftStatusById (
            aircraftModelId: $aircraftModelId
            aircraftStatusId: $aircraftStatusId
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteMutation = gql`
    mutation DigitaiDeleteAircraftModelsAircraftStatuses (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiDeleteAircraftModelsAircraftStatuses (
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;
